import { lazy } from "react";
import EstadaSuspense from "./components/EstadaSuspense";
import { isUiModeProductAdmin } from "./uiMode";

export default class DebugOutput {
  constructor(
    public prefix: string,
    public errorsOnly: boolean = false,
  ) {
    this.prefix = prefix;
    this.errorsOnly = errorsOnly;
  }

  private static outputObject(name: string, a: any) {
    let s = `<div style="background-color: #aaa">${name}</div>`;

    s += `<div style="margin-left: 20px; border: 1px solid black; padding-left: 5px; margin-bottom: 10px">`;

    for (let j in a) {
      const s1 = a[j]?.toString() || "-undefined-"; // no itx
      if (s1.startsWith("/") && s1.endsWith("/")) {
        s += `${j}:  ${a[j]} </br>`; // RegExp
      } else if (typeof a[j] == "object") {
        s += this.outputObject(j, a[j]);
      } else {
        s += `${j}: ${a[j]} </br>`;
      }
    }

    if (!a.length) {
      s += " -- leer -- <br/>"; // no itx
    }

    s += `</div>`;
    return s;
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////
  //
  // public methods
  //
  ///////////////////////////////////////////////////////////////////////////////////////////////

  output(...args: any) {
    if (!this.errorsOnly) {
      DebugOutput.output1(this.prefix, ...args);
    }
  }

  outputError(...args: any) {
    state.scriptOutput.value = state.scriptOutput.value + `<div class="scriptErrorText">`;
    DebugOutput.output1(this.prefix, ...args);
    state.scriptOutput.value = state.scriptOutput.value + `</div">`;
  }

  outputSeparator() {
    state.scriptOutput.value = state.scriptOutput.value + "--\n"; // no itx
  }

  static outputError(prefix: string, ...args: any) {
    state.scriptOutput.value = state.scriptOutput.value + `<div class="scriptErrorText">`;
    DebugOutput.output1(prefix, ...args);
    state.scriptOutput.value = state.scriptOutput.value + `</div">`;
  }

  private static output1(prefix: string, ...args: any) {
    let s = "";
    for (let i in args) {
      const a = args[i];
      if (a?.message) {
        s += `${a.message}`;
      } else if (typeof a == "object") {
        s += this.outputObject("", a);
      } else {
        s += `${a}`;
      }
      s += " ";
    }

    DebugOutput.output2(prefix + (prefix ? ":" : "") + s + "<br/>");
  }

  private static output2(s: string) {
    const comp = "./components/ScriptOutput.tsx"; // no itx

    if (!state.programStat.operationInProgress) {
      state.dialogManager.openDialog(<LazyScriptOutput />, false);
    }
    state.scriptOutput.value = state.scriptOutput.value + s;
  }
}

function LazyScriptOutput() {
  return <EstadaSuspense Component={lazy(() => import("./components/ScriptOutput"))} />;
}
